import { useLanguage } from "../i18n/LanguageContext";

export const Marquee = () => {
  const { t } = useLanguage();
  const items = [...t.marquee, ...t.marquee];

  return (
    <div className="relative py-10 sm:py-14 border-y border-[rgba(212,175,55,0.15)] overflow-hidden bg-[#050B14]" data-testid="marquee-section">
      <div className="animate-marquee flex whitespace-nowrap items-center">
        {items.map((item, i) => (
          <span key={i} className="flex items-center">
            <span className="font-display text-4xl sm:text-6xl lg:text-7xl font-light text-outline-gold px-6 sm:px-10">
              {item}
            </span>
            <span className="w-2 h-2 rotate-45 bg-[#D4AF37]/50 inline-block" />
          </span>
        ))}
      </div>
    </div>
  );
};
